const module = {
  routes: [
    {
      path: '/drivers',
      component: () => import('@/modules/drivers/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
